<template>
  <div class="custom-amount-form">
    <Header />
    <section class="main">
      <EditableProducts />
      <ReceiptSend />
      <PayMethods />
      <Footer />
    </section>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import EditableProducts from "@/components/EditableProducts.vue";
import ReceiptSend from "@/components/ReceiptSend.vue";
import PayMethods from "@/components/PayMethodsWithButton.vue";
import Footer from "@/components/Footer.vue";

export default {
  components: {
    Header,
    EditableProducts,
    ReceiptSend,
    PayMethods,
    Footer,
  },
};
</script>
